import { NETWORK_URL } from 'config'

const getNodeUrl = () => {
  return NETWORK_URL
}

export default getNodeUrl
